import React, { useState, useEffect, createRef } from "react";

import * as tiltify from "tiltify-lib";
import { Header, Footer, Hero, ProgressBar, Leaderboard } from "../layout";
import * as images from "../../images/";
import Countdown from "react-countdown";

const analytics = require("./../../utils/analyticshelper.js");

const BAC = () => {
  const scroll = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };
  const fundraisingRef = createRef();

  const [raised, setRaised] = useState(0);
  const [goal, setGoal] = useState(0);
  const [percent, setPercent] = useState(0);
  const [progress, setProgress] = useState(0);
  const [match, setMatch] = useState(true);
  const [daf, setDAF] = useState(false);
  const [leaderboard, setLeaderboard] = useState([]);
  const [filterLeaderboard, setFilterLeaderboard] = useState([]);

  useEffect(() => {
    analytics.SetPage("bac:home", "");
    analytics.PushEvent({
      eventInfo: {
        eventName: "page view",
      },
    });

    async function GetData() {
      const c = await tiltify.GetFundraiser(
        process.env.REACT_APP_EVENT_ID,
        false
      );
      setRaised(Number(c.total_amount_raised.value));
      // setRaised(40000);
      setGoal(Number(c.goal.value.replace(/\.00$/, "")));
      const l = await tiltify.GetEventUserLeaderboard(
        process.env.REACT_APP_EVENT_ID,
        51
      );
      setLeaderboard(l);
    }
    GetData();
  }, []);

  useEffect(() => {
    setPercent(Number(100 * (Number(raised) / Number(goal))));
    setProgress(percent > 100 ? 100 : percent);
  }, [goal, percent, raised]);

  useEffect(() => {
    setPercent(Number(100 * (Number(raised) / Number(goal))));
    setProgress(percent > 100 ? 100 : percent);

    setFilterLeaderboard(leaderboard.filter((word) => word.name !== "Relay"));
  }, [goal, percent, raised, leaderboard]);

  const renderer = ({ days, hours, minutes }) => {
    return (
      <span>
        {days} days {hours} hours {minutes} minutes
      </span>
    );
  };

  return (
    <div className="bac">
      <div className="overlay_lp__top">
        <Header type="normal" link="/" />
        <Hero>
          {/* <img className="bac_logo" src={images.logo} />
          <ProgressBar raised={raised} goal={goal} progress={progress} /> */}
          {/* <div className="hero__content__box">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://donate.tiltify.com/e76cf8ec-854b-49d4-b840-d87f246d51c1/details"
            >
              <span className="cta-primary">Donate</span>
            </a>
            <button
              className="hero-home__cta"
              onClick={() => {
                scroll(fundraisingRef);
              }}
            >
              <span className="cta-secondary">Register to Fundraise</span>
            </button>
          </div> */}
          {/* <div className="donate_buttons">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://donate.tiltify.com/738da34f-4c5b-4e9e-9bf3-3aaa6d4bee58/details"
            >
              <span className="cta-primary">Donate</span>
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://donate.tiltify.com/738da34f-4c5b-4e9e-9bf3-3aaa6d4bee58/incentives"
            >
              <span className="cta-primary">Register to Fundraise</span>
            </a>
          </div> */}
          <div className="hero__content__box">
            <img className="logos" src={images.logo} alt="Dr. Lupo BAC Logo" />

            <div className="countdown">
              <p>
                Countdown to livestream:{" "}
                <Countdown renderer={renderer} date={new Date(1734192000000)} />
              </p>
            </div>

            <ProgressBar raised={raised} goal={goal} progress={progress} />
            <div className="donate_buttons">
              {/* <a
                target="_blank"
                rel="noreferrer"
                href="https://donate.tiltify.com/738da34f-4c5b-4e9e-9bf3-3aaa6d4bee58/details"
              >
                <span className="cta-primary">Donate Now</span>
              </a> */}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://stjude.tiltify.com/build-against-cancer-2024/start"
              >
                <span data-track="Signup and Fundraise" className="cta-primary">
                  Sign Up and Fundraise
                </span>
              </a>
            </div>
          </div>
        </Hero>
      </div>

      <div className="steps_wrapper">
        <section className="inner-row gutters constrain overlay_lp__content prizes">
          <div className="col-12">
            <h2 className="prizes_head">Fundraising Incentives</h2>
            <p className="prizes_desc">
              Earn these limited edition incentives by fundraising alongside
              DrLupo through December 31.
            </p>
          </div>
          <div className="col-3 rewards_wrapper">
            <div className="prizes__amount">$100+ Raised</div>
            <img
              src={images.bacShirt}
              className="item"
              alt="PLAY LIVE T-shirt"
            />
            <span className="title">PLAY LIVE T-Shirt</span>
            <span>
              Raise $100 or more and receive a St. Jude PLAY LIVE T-Shirt.
            </span>
          </div>
          <div className="col-3 rewards_wrapper">
            <div className="prizes__amount">$250+ Raised</div>
            <img
              src={images.bacTumbler}
              className="item"
              alt="St. Jude Tumbler"
            />
            <span className="title">St. Jude Tumbler</span>
            <span>
              Raise $250 or more for St.&nbsp;Jude and receive this exclusive
              tumbler featuring artwork by St. Jude patient Ty.
            </span>
          </div>
          <div className="col-3 rewards_wrapper">
            <div className="prizes__amount">$500+ Raised</div>
            <img src={images.bacGW} className="item" alt="TCG Bundle" />
            <span className="title">St. Jude TCG bundle</span>
            <span>
              Raise $500 or more and receive a St. Jude playmat, card sleeves
              and deck box.
            </span>
          </div>
          <div className="col-3 rewards_wrapper">
            <div className="prizes__amount">$1000+ Raised</div>
            <img src={images.placeholder} className="item" alt="Relay Coin" />
            <span className="title">Fever Fighter Vinyl</span>
            <span>
              Raise $1000 or more for St. Jude and receive an exclusive Fever
              Fighter vinyl figure.
            </span>
          </div>
          <div className="col-12">
            <a
              href="https://stjude.tiltify.com/build-against-cancer-2024/start"
              rel="noreferrer"
              target="_blank"
            >
              <span data-track="Signup and Fundraise" className="cta-primary">
                Sign Up and Fundraise
              </span>
            </a>
          </div>
        </section>
        {/* <section className="inner-row gutters constraing overlay_lp__content c_challenge">
          <div className="col-12">
            <h2>Help amplify the campaign</h2>
            <p>
              By creating a Tiltify Amplify link you can help fundraise toward
              this year's goal for BAC!
            </p>
          </div>
          <div className="col-4 steps">
            <img alt="signup" src={images.mouseIcon} />
            <p className="steps__content">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://tiltify.com/@drlupo/buildagainstcancer2023/amplify"
              >
                Click here
              </a>{" "}
              to generate an Amplify link to support the BAC campaign.
            </p>
          </div>
          <div className="col-4 steps">
            <img alt="participate" src={images.starIcon} />
            <p className="steps__content">
              Log into your Tiltify account or input your email then click
              “Submit” to generate a custom amplify link
            </p>
          </div>
          <div className="col-4 steps">
            <img alt="share" src={images.amplifyIcon} />
            <p className="steps__content">
              Share your Amplify link via social, email and/or text to drive
              donations the BAC campaign.{" "}
              <a href="https://info.tiltify.com/support/solutions/articles/43000697330-amplify">
                Learn more here
              </a>
              .
            </p>
          </div>
          <div className="col-12">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://stjude.tiltify.com/build-against-cancer-2024/start"
            >
              <span className="cta-primary">Sign Up and Fundraise</span>
            </a>
          </div>
        </section> */}
      </div>
      <div className="incentives_wrapper">
        <section className="inner-row gutters constrain overlay_lp__content prizes">
          <Leaderboard leaderboard={filterLeaderboard} />
          {/* <div className="col-12">
            <a
              href="https://stjude.tiltify.com/build-against-cancer-2024/start"
              rel="noreferrer"
              target="_blank"
            >
              <span className="cta-primary">Sign Up and Fundraise</span>
            </a>
          </div> */}
        </section>
      </div>
      {/* <section className="inner-row gutters constraing overlay_lp__content c_challenge cars">
        <div className="cars-wrapper">
          <div className="col-12">
            <p>
              Your car donation can help St. Jude fight childhood cancer and
              other life-threatening diseases. The money from the sale of your
              vehicle will contribute to our lifesaving mission: Finding cures.
              Saving children®.
            </p>
          </div>
        </div>
      </section> */}
      <section className="inner-row gutters constraing overlay_lp__content ways">
        <div className="col-12">
          <h2>New ways to support Build Against Cancer</h2>
          <p>
            Below are new ways to make your dollar count even more for the kids
            of St.&nbsp;Jude
          </p>
        </div>
        <div className="col-2"></div>
        <div className="col-8">
          <ol>
            <li
              className={match ? "nav-item expanded" : "nav-item"}
              onClick={() => {
                setMatch(!match);
              }}
            >
              <span>
                <span className="title">Employer-Matching Gifts</span>
                <span className="cta-text">
                  {match ? "Collapse" : "Expand Info"}
                </span>
              </span>
            </li>
            <li className={match ? "item expanded" : "item"}>
              <p>
                Did you know, thousands of companies match their employees'
                donations to St.&nbsp;Jude? You can now request to have your
                donation matched and have the employer-match applied to the
                Tiltify campaign!
              </p>
              <ul>
                <li>
                  <strong>Step 1: </strong>Make a personal donation to the
                  Tiltify campaign.
                </li>
                <li>
                  <strong>Step 2: </strong>On the donation summary screen, click
                  “Search employers” to see if your employer has a matching gift
                  program. If so, you'll find details specific to your company's
                  program.
                </li>
                <li>
                  <strong>Step 3: </strong>After selecting your employer, you
                  will receive an email with instructions on how to submit your
                  matching gift request. After submitting your request and
                  clicking the green button in your email, the matching gift
                  will be credited to the campaign total within 24 hours.
                </li>
                <li>
                  <strong>Note: </strong>Employer-matching gifts count towards
                  the campaign total but are not eligible for donation rewards
                  offered.
                </li>
              </ul>
              <p>
                <em>
                  Didn't request your match when you donated? If you forgot to
                  search your employer at the time of donation or your company
                  requires you to donate through your company portal,{" "}
                  <a href="mailto:playlive@stjude.org">contact us</a> and we
                  will assist in manually crediting for a requested match.{" "}
                </em>
              </p>
              <p>
                Didn't receive the email?{" "}
                <a href="mailto:playlive@stjude.org">Contact us</a>.
              </p>
            </li>
          </ol>
        </div>
        <div className="col-2"></div>
        {/* <div className="col-2"></div>
        <div className="col-8">
          <ol>
            <li
              className={car ? "nav-item expanded" : "nav-item"}
              onClick={() => {
                setCar(!car);
              }}
            >
              <span>
                <span className="title">
                  Charitable Adult Rides and Services (CARS)
                </span>

                <span className="cta-text">
                  {car ? "Collapse" : "Expand Info"}
                </span>
              </span>
            </li>
            <li className={car ? "item expanded" : "item"}>
              <p>
                Your{" "}
                <a href="https://www.stjude.org/get-involved/other-ways/cars-donation.html?sc_icid=wtg-lz-car">
                  car donation
                </a>{" "}
                can help St. Jude fight childhood cancer and other
                life-threatening diseases. The money from the sale of your
                vehicle will contribute to our lifesaving mission:{" "}
                <em>Finding cures. Saving children®</em>.
              </p>

              <p>
                We've partnered with Charitable Adult Rides and Services (CARS)
                to make donating your car easy. Vehicle donations are eligible
                for tax deductions.
              </p>
              <p>
                Any donation made through CARS on behalf of Ben Lupo will
                contribute to the BAC fundraising campaign.{" "}
                <a href="https://www.stjude.org/get-involved/other-ways/cars-donation.html?sc_icid=wtg-lz-car">
                  Learn more about how you can donate your car to St. Jude
                </a>
                .
              </p>
              <p>
                Need help? <a href="mailto:playlive.stjude.org">Contact us</a>
              </p>
            </li>
          </ol>
        </div>
        <div className="col-2"></div> */}
        <div className="col-2"></div>
        <div className="col-8">
          <ol>
            <li
              className={daf ? "nav-item expanded" : "nav-item"}
              onClick={() => {
                setDAF(!daf);
              }}
            >
              <span>
                <span className="title">Donor-Advised Fund Giving</span>

                <span className="cta-text">
                  {daf ? "Collapse" : "Expand Info"}
                </span>
              </span>
            </li>
            <li className={daf ? "item expanded" : "item"}>
              <p>
                You may now use your donor-advised fund to support St.&nbsp;Jude
                and credit your gift to the Tiltify campaign!
              </p>
              <ul>
                <li>
                  <strong>Step 1: </strong>Recommend a gift by contacting your
                  fund administrator, using your fund administrator app, or by
                  granting online.
                </li>
                <li>
                  {/* <strong>Step 2: </strong>Request a donor-advised fund
                    distribution to St.&nbsp;Jude from your financial
                    institution. Save the confirmation page for your requested
                    distribution. */}
                  <strong>Step 2: </strong>Save the confirmation page for your
                  requested distribution.
                </li>
                <li>
                  <strong>Step 3: </strong>Then visit{" "}
                  <a
                    href="https://www.stjude.org/tiltifycredit"
                    target="_blank"
                    rel="noreferrer"
                  >
                    stjude.org/TiltifyCredit
                  </a>{" "}
                  to fill out the form to credit your requested distribution to
                  this Tiltify campaign. Donations will be added within one
                  business day.
                </li>
                <li>
                  <strong>Note: </strong>DAF gifts count towards the campaign
                  total but are not eligible for donation rewards offered.
                </li>
              </ul>
              <p>
                Need Help? <a href="mailto:playlive@stjude.org">Contact us</a>.
              </p>
            </li>
          </ol>
        </div>
        <div className="col-2"></div>
      </section>

      {/* <div className="fundraise_wrapper">
        <section
          className="inner-row gutters constraing overlay_lp__content c_challenge fundraise"
          ref={fundraisingRef}
        >
          <div className="col-12">
            <h2>Join the Build Against Cancer Community Challenge</h2>
            <p>
              Create your own fundraiser to join DrLupo in raising money for St.
              Jude Children's Research Hospital®.
            </p>
          </div>
          <div className="col-4 steps">
            <img alt="signup" src={images.laptopIconWhite} />
            <p className="steps__header">Sign Up</p>
            <p className="steps__content">
              Get started by{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://tiltify.com/st-jude-children-s-research-hospital/build-against-cancer-2022/start"
              >
                signing up
              </a>{" "}
              and creating your campaign through Tiltify.
            </p>
          </div>
          <div className="col-4 steps">
            <img alt="participate" src={images.partyIconWhite} />
            <p className="steps__header">Participate</p>
            <p className="steps__content">
              Fundraise solo or with a team and{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://playlive.experience.stjude.org/"
              >
                utilize our St. Jude toolkit
              </a>{" "}
              to magnify your fundraising campaign.
            </p>
          </div>
          <div className="col-4 steps">
            <img alt="share" src={images.shareIconWhite} />
            <p className="steps__header">Share</p>
            <p className="steps__content">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://playlive.experience.stjude.org/instagram-landing/"
              >
                Download these social media assets
              </a>{" "}
              and post your campaign on social media and tag your friends and
              family.
            </p>
          </div>
          <div className="col-12">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://tiltify.com/st-jude-children-s-research-hospital/build-against-cancer-2022/start"
            >
              <span className="cta-primary">Sign Up and Fundraise</span>
            </a>
          </div>
        </section>
      </div> */}
      {/* <section className="inner-row gutters constraing overlay_lp__content c_challenge">
        <div className="col-12">
          <div className="inner-row gutters constraing instructions">
            <div className="col-8">
              <h2>Jumpstart Your Campaign</h2>
              <p>
                While fundraising for St. Jude kids, HAVE FUN. Asking for
                donations to reach your milestones and goals is expected, so
                don't hesitate to do so continually throughout your campaign.
              </p>

              <p>
                Make the Build Against Cancer Sticker Pack available to your
                donors of $60+ by adding the reward to your campaign!{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://info.tiltify.com/support/solutions/articles/43000662649-adding-incentives-cause-rewards"
                >
                  Here's how
                </a>
                .
              </p>
              <p>
                Below are several incentive and milestone ideas but feel free to
                create your own! Incentives don't have to cost additional money
                and can be as simple as:
              </p>
              <ul>
               
                <li>
                  Try using our handy social media assets, like our donation
                  bingo card, to drive traffic to your fundraising campaign!{" "}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://playlive.experience.stjude.org/fb-landing/"
                  >
                    Download them here
                  </a>
                  !
                </li>
                <li>
                  Create fun donation incentives and fundraising milestones to
                  help drive urgency for your friends and family to donate. They
                  can be simple and silly things:
                  <ul>
                    <li>
                      Donate $X+ and I'll share your celebrity doppelganger
                    </li>
                    <li>My dog gets a treat for each donation of $Y+</li>
                    <li>
                      I'll add the names of every donor of $Z+ to a “thank you
                      wall”
                    </li>
                    <li>
                      Remind your donors to check if their employers offer a
                      matching gift program and request credit for any match
                      requests submitted!
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="col-4">
              <div className="prizes">
                <div className="prizes__amount">$60+ Donation Reward</div>
                <img
                  src={images.bacSticker}
                  className="item"
                  alt="BAC Sticker Pack"
                />
                <p>
                  <strong>BAC Sticker Pack</strong>
                </p>
                <p>
                  Add this exclusive DrLupo BAC sticker pack reward to your
                  fundraising campaign for your donors to claim.{" "}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://info.tiltify.com/support/solutions/articles/43000662649-adding-incentives-cause-rewards"
                  >
                    Here's how
                  </a>
                </p>
              </div>
            </div>
            <div className="col-12 matching">
              <h2>New ways for your donors to give</h2>
              <p>
                <strong>Matching Gifts</strong>
              </p>

              <p>
                A donor's employer may offer a matching gift program. Share the
                page below so donors can lookup details on any programs offered
                by their employer and fill out the form to have a requested
                match added to your fundraising campaign.
              </p>

              <p>
                <strong>Donor Advised Funds</strong>
              </p>

              <p>
                A donor may have a donor advised fund they would like to use to
                make a gift to your campaign. Share the page below so donors can
                learn more about requesting a distribution from for St. Jude and
                fill out the form to credit that gift to your campaign!
              </p>

              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.stjude.org/tiltifycredit"
              >
                <span className="cta-primary">See New Ways to Give</span>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section
        className="inner-row gutters constrain overlay_lp__content prizes"
        ref={prizesRef}
      >
        <div className="col-12">
          <h2>Fundraising Incentives</h2>
          <p>
            Earn these limited edition incentives by fundraising alongside
            DrLupo.
          </p>
        </div>
        <div className="col-6">
          <div className="prizes__amount">Top 10</div>
          <img
            src={images.bacPosterFrame}
            className="item"
            alt="BAC Poster Framed & Signed"
          />
          <p>
            <strong>Framed & Autographed BAC Poster</strong>
          </p>
          <p>Receive an exclusive framed BAC poster signed by DrLupo</p>
        </div>
        <div className="col-6">
          <div className="prizes__amount">Raise $100+</div>
          <img src={images.bacPoster} className="item" alt="BAC Poster" />
          <p>
            <strong>BAC Poster</strong>
          </p>
          <p>Receive an exclusive BAC poster</p>
        </div>
        <div className="inner-row gutters constrain overlay_lp__content leaderboard">
          <div className="col-12">
            <h2>Top Fundraisers</h2>
          </div>
          <div className="col-4">
            {individual.slice(0, 10).map((individual) => (
              <div className="leaderboard_wrapper" key={individual.id}>
                <div className="leaderboard_wrapper__name">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://info.tiltify.com/support/solutions/articles/43000662649-adding-incentives-cause-rewards"
                  >
                    Here's how
                  </a>
                </p>
              </div>
            ))}
          </div>
          <div className="col-4">
            {individual.slice(10, 20).map((individual) => (
              <div className="leaderboard_wrapper" key={individual.id}>
                <div className="leaderboard_wrapper__name">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`https://tiltify.com` + individual.url}
                  >
                    {individual.name}
                  </a>
                </div>
                <div className="leaderboard_wrapper__amount">
                  ${individual.amount.amount}
                </div>
              </div>
            ))}
          </div>
          <div className="col-4">
            {individual.slice(20, 30).map((individual) => (
              <div className="leaderboard_wrapper" key={individual.id}>
                <div className="leaderboard_wrapper__name">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`https://tiltify.com` + individual.url}
                  >
                    {individual.name}
                  </a>
                </div>
                <div className="leaderboard_wrapper__amount">
                  ${individual.amount.amount}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <Footer />
    </div>
  );
};

export default BAC;
